export const environment = {
  production: true,
  appVersion: require('../../package.json').version,
  useProxy: false,
  wss: 'wss://messenger.soft-angel.ru:8001',
  tg: 'https://messenger.soft-angel.ru:8001',
  leads: 'https://messenger.soft-angel.ru:8078',
  tdata: 'https://messenger.teleseller.ru:8001',
  sender: 'https://messenger.soft-angel.ru:8003',
  vk: 'https://messenger.soft-angel.ru:2389',
  yaCounterId: 104137219
};
